import RowStack from "@common-components/common/row-stack/RowStack";

import { Session } from "@common-models/session";
import AndroidIcon from '@mui/icons-material/Android';
import AppleIcon from '@mui/icons-material/Apple';
import CloseIcon from '@mui/icons-material/Close';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Slide, Stack, Tab, Tabs, } from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import { sessionSelectOneObjectByQuery } from "@common-reducers/DBServiceThunks";
import { toggleHowToScanQrModal } from "@common-reducers/MainReducer";
import { getRuntimeUrl } from "@common-services/storage";
import { useAppDispatch, useAppSelector } from "@common-reducers/hooks/store.hook";
import { namespace } from "@common-config/constants";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children: React.ReactElement<any, any> },
  ref: React.Ref<unknown>
) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const disconnectImage = getRuntimeUrl("img/disconnect.jpg");

const QrHowToScan = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation(namespace);
  const session: Session | undefined = useAppSelector((state) => sessionSelectOneObjectByQuery(state.DBSessionReducer, {}))
  const isHowToScanQrModalOpen = useAppSelector((state) => state.MainReducer.isHowToScanQrModalOpen);
  const [value, setValue] = useState(0);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const sessionNotActive = () => {
    return (
      <div style={{ padding: '48px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: "center" }}>
          <div style={{ marginRight: '32px', maxWidth: '380px' }}>
            <div style={{ fontSize: '28px', marginBottom: '32px' }}>
              <div>{t('qr.howTo.offlineTitle', 'To keep using Blueticks when you are offline:')}</div>
              <div style={{ fontSize: '14px', margin: '10px 0' }}> {t('qr.howTo.offlineSubtitle', 'Blueticks will send your messages even if your phone/computer is turned off')}</div>
            </div>
            <Tabs sx={{ "& .MuiTab-root": { fontFamily: "Poppins", textTransform: "capitalize", color: "#809BA8", minHeight: "50px", width: "180px" } }} value={value} onChange={handleChange} aria-label={t('qr.howTo.deviceTabs', 'Device tabs')}>
              <Tab icon={<AndroidIcon />} label="Android" />
              <Tab icon={<AppleIcon />} label="iPhone" />
            </Tabs>

            {/* Android Instructions */}
            {value === 0 &&
              <Stack mt={2} spacing={2}>
                <Box> {t('qr.howTo.android.step1', '1. Open WhatsApp on your Android primary phone.')}</Box>
                {/* The menu ICON sits mid-sentence, so the step is two keys with the glyph
                    between them rather than one key with a literal tail — a single key would
                    have forced the icon to the end of the line in every language. */}
                <RowStack>{t('qr.howTo.android.step2Tap', '2. Tap')} <MoreVertIcon /> {t('qr.howTo.android.step2Rest', '> Linked devices > Link a device.')}</RowStack>
                <Box>{t('qr.howTo.android.step3', '3. Unlock your primary phone:')}
                  <ul>
                    <li style={{ marginBlockEnd: "8px" }}>{t('qr.howTo.unlockBiometric', 'If your device has biometric authentication, follow the on-screen instructions.')}</li>
                    <li>{t('qr.howTo.unlockPin', 'If you don’t have biometric authentication enabled, you’ll be prompted to enter the PIN you use to unlock your phone.')}</li>
                  </ul></Box>
                <Box>{t('qr.howTo.android.step4', '4. Point your Android phone at the screen of the device you want to link to scan the QR code.')}</Box>
              </Stack>


            }

            {/* Iphone Instructions */}

            {value === 1 &&

              <Stack mt={2} spacing={2}>
                <Box> {t('qr.howTo.iphone.step1', '1. Open WhatsApp on your iPhone primary phone.')}</Box>
                <RowStack>{t('qr.howTo.iphone.step2', '2. Go to WhatsApp Settings > Linked Devices > Link a Device.')}</RowStack>
                <Box>{t('qr.howTo.iphone.step3', '3. Unlock your iPhone if you’re on iOS 14 or above:')}
                  <ul >
                    <li style={{ marginBlockEnd: "8px" }}>{t('qr.howTo.iphone.unlockFaceId', 'Use Touch ID or Face ID to unlock.')}</li>
                    <li>{t('qr.howTo.unlockPin', 'If you don’t have biometric authentication enabled, you’ll be prompted to enter the PIN you use to unlock your phone.')}</li>
                  </ul></Box>
                <Box>{t('qr.howTo.iphone.step4', '4. Point your iPhone at the screen of the device you want to link to scan the QR code.')}</Box>
              </Stack>


            }
          </div>
          {/* <div style={{ fontSize: '24px', padding: '48px', paddingTop: '0' }}>
            Blueticks will send your messages even if your phone/computer is turned off
          </div> */}
          <div style={{ backgroundColor: 'rgba(0, 0, 0, 0.025)', display: 'flex', justifyContent: 'center' }}>
            <video controls style={{ width: '100%', height: 'auto' }}>
              <source src="https://web.whatsapp.com/whatsapp-webclient-login_c09223f0813e7c3adc16476cba2a5d0d.mp4" type="video/mp4" />
              {t('qr.howTo.videoUnsupported', 'Your browser does not support the video tag.')}
            </video>
          </div>
        </div>
      </div>
    );
  };

  const sessionActive = () => {
    return (
      <div style={{ display: 'flex', justifyContent: 'space-between', padding: '48px' }}>
        <div style={{ marginInlineEnd: '32px', maxWidth: '380px' }}>
          <div style={{ fontSize: '28px', marginBottom: '32px' }}>
            <div>{t('qr.howTo.disconnectTitle', 'To disconnect Blueticks:')}</div>
          </div>
          {/* The four steps carried their own "1. " … "3. " prefixes INSIDE an
              <ol>, so the browser rendered "1. 1. Open WhatsApp…" — and the last
              two were both numbered 3, so the list also skipped 4. The numbers
              are the list's job; the strings say only what to do. This also
              spares every translator from renumbering by hand. */}
          <ol>
            <li style={{ fontSize: '18px', marginBottom: '18px', lineHeight: '28px' }}>{t('qr.howTo.disconnect1', 'Open WhatsApp on your phone')}</li>
            <li style={{ fontSize: '18px', marginBottom: '18px', lineHeight: '28px' }}>{t('qr.howTo.disconnect2', 'Tap Menu or Settings and select Linked Devices')}</li>
            <li style={{ fontSize: '18px', marginBottom: '18px', lineHeight: '28px' }}>{t('qr.howTo.disconnect3', 'Press on Blueticks in the list of devices')}</li>
            <li style={{ fontSize: '18px', marginBottom: '18px', lineHeight: '28px' }}>{t('qr.howTo.disconnect4', 'Select Logout')}</li>
          </ol>
          <div style={{ fontSize: '24px' }}>
            {t('qr.howTo.disconnectNote', 'If you disconnect you will have to keep WhatsApp web open so Blueticks can send your scheduled messages')}
          </div>
        </div>
        <div style={{ width: '260px', height: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <img alt="" src={disconnectImage} style={{ height: '100%' }} />
        </div>
      </div>
    );
  };

  return <>
    <Dialog
      TransitionComponent={Transition}
      maxWidth='lg'
      open={isHowToScanQrModalOpen}
      onClose={() => { dispatch(toggleHowToScanQrModal(false)) }}
      PaperProps={{
        sx: {
          backgroundColor: 'var(--color-surface)',
          color: 'var(--color-text)',
        }
      }}
    >
      <DialogTitle sx={{ m: 0, p: 2 }}>
        <IconButton
          aria-label={t('qr.howTo.close', 'close')}
          onClick={() => { dispatch(toggleHowToScanQrModal(false)) }}
          sx={{
            position: 'absolute',
            insetInlineEnd: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <div>
          {session && session.status === "connected" && sessionActive()}
          {session && session.status === "qrcode" && sessionNotActive()}
        </div>
      </DialogContent>
    </Dialog>
  </>;
}

export default QrHowToScan;
